var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 13.0001H3.66663L1.66663 15.0001V3.66675C1.66663 2.56675 2.56663 1.66675 3.66663 1.66675H12.3333C13.4333 1.66675 14.3333 2.56675 14.3333 3.66675V11.0001C14.3333 12.1001 13.4333 13.0001 12.3333 13.0001Z",
    fill: "#009688"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.33325C8.55228 8.33325 9 7.88554 9 7.33325C9 6.78097 8.55228 6.33325 8 6.33325C7.44772 6.33325 7 6.78097 7 7.33325C7 7.88554 7.44772 8.33325 8 8.33325Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 8.33325C11.8855 8.33325 12.3333 7.88554 12.3333 7.33325C12.3333 6.78097 11.8855 6.33325 11.3333 6.33325C10.781 6.33325 10.3333 6.78097 10.3333 7.33325C10.3333 7.88554 10.781 8.33325 11.3333 8.33325Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 8.33325C5.21891 8.33325 5.66663 7.88554 5.66663 7.33325C5.66663 6.78097 5.21891 6.33325 4.66663 6.33325C4.11434 6.33325 3.66663 6.78097 3.66663 7.33325C3.66663 7.88554 4.11434 8.33325 4.66663 8.33325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.a76fcd4d4b9f17eb524cac0e860b5c57.svg";
export { ForwardRef as ReactComponent };